import { AnimationReferenceMetadata, transition, trigger, useAnimation } from '@angular/animations';
import { AfterViewInit, Component, OnInit, inject } from '@angular/core';
import { fadeInRight } from 'ng-animate';
import { FitupService } from '../../../shared/service/fitup/fitup.service';
import { Image, ThinkModelComponent } from '../../../shared/model/fitup/generic.model';
import { ResponsiveService } from '../../../shared/service/fitup/responsive.service';

declare global {
  interface Window {
    hbspt: any;
  }
}

@Component({
  selector: 'app-mordern-client-capture',
  styleUrl: './mordern-client-capture.component.scss',
  templateUrl: './mordern-client-capture.component.html',
  animations: [
    trigger('fadeInRight', [transition('* => *', useAnimation(fadeInRight, {
      // Set the duration to 5seconds and delay to 0seconds
      params: { timing: 1.5, delay: 1 }
    }))])
  ],
})

export class MordernClientCaptureComponent implements OnInit, AfterViewInit {
  private readonly _fitUpSvc = inject(FitupService)
  private readonly _responsiveSvc = inject(ResponsiveService)
  private appModernFunction?: ThinkModelComponent;
  public screenSize$ = this._responsiveSvc.screenSize$
  public fadeInRight?: AnimationReferenceMetadata;
  public headText?: string
  public subText?: string
  public functionImage?: Image

  constructor() { }

  ngAfterViewInit() {
    this.setupHubSpotForm();
  }
  ngOnInit() {
    this.getDados()
  }

  setupHubSpotForm() {
    window['hbspt'].forms.create({
      region: "na1",
      portalId: "45356431",
      formId: "b91b59ff-225e-4861-9d05-0289a9c8ab2e",
      target: '#hubspotForm',
      onFormReady: function ($form: { querySelector: (arg: string) => any; }) {
        setTimeout(() => {
          const actions = $form.querySelector('.actions');
          const button = $form.querySelector('.hs-button');
          const star = $form.querySelector('.hs-form-required');

          if (actions) {
            actions.style.padding = "17px 0px 0px 0px";
            actions.style.margin = "17px 0px 0px 0px";
            actions.style.height = "60px"
          }
          if (star) {
            star.style.color = "black";
          }
          if (button) {
            const container = document.createElement('div');

            container.style.backgroundColor = 'white';
            container.style.width = '100%';
            container.style.height = '130px';
            container.style.position = "relative";
            container.style.bottom = "0px";

            button.parentNode.insertBefore(container, button.nextSibling);
            button.style.background = '#035A52';
            button.style.border = '1px solid #035A52';
            button.style.marginBottom = '0px';
          }
        }, 1000);
      }
    });
  }
  getDados() {
    this._fitUpSvc.getStrapiDataObservable().subscribe(updateData => {
      this.appModernFunction = updateData
      const component = this._fitUpSvc.getComponentData('app_modern_function2').data.attributes
      this.headText = component.headText
      this.subText = component.button.subText
      this.functionImage = component.functionImage
    })
  }
}
